<template>
  <div id="app">
    <router-view v-if="isRoutrAlive"></router-view>
  </div>
</template>
<script>
  // import DevicePixelRatio from './devicePixelRatio'
export default {
  provide(){
    return {
      reload : this.reload
    }
  },
  data() {
    return {
      isRoutrAlive:true,
      flag: false
    };
  },
  created(){
    // new DevicePixelRatio().init()
    // window.onload = window.onresize = function () {
    //   document.body.style.zoom = 0.5
    // };
    // this.detectZoom()

    // var t = window.devicePixelRatio
    // if(t != 1){ // 如果进行了缩放，也就是不是1
    //   document.body.style.zoom =1; // 就去修改页面的缩放比例，这个公式我自己算的，不准确，勉强。
    // }



  },
  methods:{
    reload(){
      this.isRoutrAlive = false;
      this.$nextTick(function(){
        this.isRoutrAlive = true
      })
    },

    detectZoom() {
      let ratio = 0
      const screen = window.screen
      const ua = navigator.userAgent.toLowerCase()
      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio
      } else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI
        }
      } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        ratio = window.outerWidth / window.innerWidth
      }
      if (ratio) {
        ratio = Math.round(ratio * 100)
      }
      // return ratio
      if(ratio*1 > 100 && ratio*1 <= 125){
        // window.onload = window.onresize = function () {
        //   document.body.style.zoom = 0.8
        // };
        window.resizeBy(50, 0);
      }else if(ratio*1 > 125 && ratio*1 <= 150){
        window.onload = window.onresize = function () {
          document.body.style.zoom = 0.6
        };
      }else if(ratio*1 > 150){
        window.onload = window.onresize = function () {
          document.body.style.zoom = 0.5
        };
      }
    },

  }
}
</script>
<style>
html,
body {
  width: 100%;
  height: 100%;
  background: #fff;
  margin: 0 auto;
  overflow: hidden;

  /*width: 1920px; // 固定值*/
  /*height: 1080px; // 固定值*/
  transform-origin: 0 0 0; /*指定缩放的基本点*/
  -moz-transform-origin: 0 0 0;
  -ms-transform-origin: 0 0 0;
  -webkit-transform-origin: 0 0 0;
  -o-transform-origin: 0 0 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
input[type=number] {  
    -moz-appearance:textfield;  
}  
input[type=number]::-webkit-inner-spin-button,  
input[type=number]::-webkit-outer-spin-button {  
    -webkit-appearance: none;  
    margin: 0;  
}  
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
body .el-table th.gutter{
    display: table-cell!important;
}
 
body .el-table colgroup.gutter{
    display: table-cell!important;
}
.el-table__footer-wrapper tbody td, .el-table__header-wrapper tbody td{
    color: #4f81bd;
    font-size: 15px;
  }
</style>
